import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig.js";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming you have a similar function to log actions
import {
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  getUserDataById,
  queryCollection,
} from "../../models/DataFunctions.js";
import dayjs from "dayjs";

function getUrlAndText(content) {
  let url = "";
  let text = "";
  if (content) {
    for (let i = 0; i < content.length; i++) {
      if (content[i].startsWith("http")) {
        url = content[i];
      } else {
        text = content[i];
      }
    }
  }

  return {
    url,
    value: text,
  };
}

const sendIntermediaryReport = async (
  folder_id,
  control_id,
  token,
  prefix,
  handleClickVariant
) => {
  let url = prefix + `folders/${folder_id}/intermediary-report`;
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const folderData = await getDocDataById("folder", folder_id);
  let conductor_name = "Particulier";
  if (folderData.conductor_id) {
    let conductor = await getUserDataById(folderData.conductor_id);
    conductor_name = conductor?.display_name;
  }
  const member = await getUserDataById(folderData.members_id[0]);
  const master = await getOrgDataById(folderData.master_id);

  const body_text =
    "Objet du rapport\n" +
    "Présentation des résultats du test d’infiltrométrie intermédiaire réalisé sur la partie extension du bâtiment.\n\n" +
    "Contexte et méthodologie\n" +
    "Conformément aux exigences de la réglementation thermique (RT2012, RE2020), un test d’infiltrométrie intermédiaire a été réalisé sur la partie extension du bâtiment, avant la pose définitive des isolants. " +
    "Ce test vise à évaluer l’étanchéité à l’air de l’enveloppe, à identifier d’éventuelles fuites et à s’assurer de la conformité des travaux avant la phase finale d’isolation.\n\n" +
    "Le test a été effectué selon la norme NF EN 13829, à l’aide d’une porte soufflante installée sur l’ouverture principale de l’extension. " +
    "L’ensemble des autres ouvertures communicantes avec la partie existante du bâtiment a été obturé afin d’assurer la fiabilité des mesures.\n\n" +
    "Résultats du test\n" +
    "Le test d’infiltrométrie intermédiaire a permis de mesurer la perméabilité à l’air de l’extension. " +
    "Les valeurs obtenues sont conformes aux seuils réglementaires applicables, attestant d’une bonne étanchéité à l’air de l’enveloppe bâtie.\n\n" +
    "Aucune fuite d’air significative n’a été détectée au niveau des liaisons menuiseries/bâti, des passages de gaines ou des interfaces entre éléments constructifs. " +
    "Les zones à surveiller identifiées lors de précédentes interventions ont été vérifiées et corrigées si nécessaire.\n\n" +
    "Conclusion\n" +
    "Le test d’infiltrométrie intermédiaire réalisé sur la partie extension du bâtiment est concluant. " +
    "L’étanchéité à l’air de l’enveloppe est conforme aux exigences de la réglementation thermique en vigueur. " +
    "Les travaux peuvent se poursuivre en toute confiance, et la phase de pose des isolants peut être engagée.";

  let body = {
    logo_url: master.logo,
    report: {
      number: dayjs().format("YYYYMMDDHHmmss"),
      date: dayjs().format("DD/MM/YYYY"),
    },
    author: {
      name: member.display_name,
      company: master.name,
    },
    partner: {
      name: conductor_name,
      company:
        folderData.client_type === "particulier"
          ? folderData.nom
          : folderData.marque,
    },
    client: {
      nom: folderData.nom || "",
      adresse: folderData.adresse || "Pas d'adresse renseignée",
      city: folderData.ville || "Pas de ville renseignée",
      postal_code: folderData.postal || "Pas de code postal renseigné",
    },
    body_text: body_text,
  };

  try {
    let start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return true;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return true;
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();

    let end = new Date();
    let elapsed = end - start;
    // Add log document (avoid passing full document references)
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      const responseJson = JSON.parse(responseText);
      return responseJson;
    } else {
      // Handle error response
      console.error(`Failed to send rt batiment: ${response.status}`);
      return false;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return false;
  }
};

export default sendIntermediaryReport;
